// 在HTML的<head>标签内直接嵌入此脚本 -->
let browser_lang = 'en';
(function() {
    'use strict';
    // 配置参数（根据实际需求修改）
    const config = {
        defaultLang: 'en',
        langMap: {
            en: {
                path: '/',
                isRoot: true
            },
            zh: {
                path: '/cn/'
            },
            ja: {
                path: '/jp/'
            }
        },
        storageKey: 'userLang',
        forceParam: 'lang',
        // 严格中文地区代码（仅大陆/港澳）
        strictChineseRegions: [
            'CN',
            'HK',
            'MO'
        ],
        // IP检测超时时间（毫秒）
        ipCheckTimeout: 2000
    };
    // ====================== 核心工具方法 ======================
    function getCurrentLangFromURL() {
        const path = location.pathname;
        for (const [lang, info] of Object.entries(config.langMap)){
            if (path.startsWith(info.path) && info.path !== '/') return lang;
        }
        return config.defaultLang; // 默认英文
    }
    // ====================== 同步语言检测 ======================
    function detectTargetLanguage() {
        // 1. 检查本地存储
        const storedLang = localStorage.getItem(config.storageKey);
        if (storedLang) return storedLang;
        // 2. 浏览器语言检测
        const navLang = navigator.language || navigator.userLanguage;
        const browserLang = navLang.split('-')[0];
        return config.langMap[browserLang] ? browserLang : config.defaultLang;
    }
    // ====================== 中文用户IP验证 ======================
    function shouldCheckChineseIP(detectedLang) {
        return detectedLang === 'zh' && !location.search.includes(config.forceParam) && !document.cookie.includes('zh_verified');
    }
    function verifyChineseRegion() {
        return new Promise((resolve)=>{
            // 超时控制
            const timeoutId = setTimeout(()=>{
                document.cookie = "zh_verified=false;path=/;max-age=300"; // 5分钟缓存
                resolve(false);
            }, config.ipCheckTimeout);
            // 使用JSONP方案避免CORS问题
            const callbackName = 'ipCallback_' + Date.now();
            window[callbackName] = (data)=>{
                clearTimeout(timeoutId);
                const isValid = config.strictChineseRegions.includes(data.country);
                document.cookie = `zh_verified=${isValid};path=/;max-age=3600`; // 1小时缓存
                resolve(isValid);
            };
            const script = document.createElement('script');
            script.src = `https://ipapi.co/json/?callback=${callbackName}`;
            script.onerror = ()=>{
                clearTimeout(timeoutId);
                resolve(false);
            };
            document.head.appendChild(script);
        });
    }
    // ====================== 路径处理 ======================
    function applyLanguage(lang) {
        // 获取当前路径（移除已有语言前缀）
        let currentPath = location.pathname;
        Object.values(config.langMap).forEach((info)=>{
            if (info.path !== '/' && currentPath.startsWith(info.path)) currentPath = currentPath.slice(info.path.length - 1);
        });
        // 构建新路径
        const targetInfo = config.langMap[lang];
        let newPath = targetInfo.isRoot ? currentPath : targetInfo.path + currentPath.replace(/^\//, '');
        // 路径标准化
        newPath = newPath.replace(/\/+/g, '/').replace(/\/$/, '/index.html').replace(/index\.html$/, '');
        // 避免重复跳转
        if (newPath !== location.pathname.replace(/\/$/, '')) window.location.href = newPath + location.search;
    }
    function getUrlLangParam() {
        const params = new URLSearchParams(window.location.search);
        return params.get('lang'); // 直接返回lang参数值，不存在则返回null
    }
    function shouldSwitchToTargetLang(currentLang, targetLang) {
        // 如果已经是目标语言，不需要切换
        return currentLang !== targetLang;
    }
    // ====================== 路径构建 ======================
    function buildNewPath(targetLang) {
        const currentLang = getCurrentLangFromURL();
        let currentPath = location.pathname;
        // 移除当前语言前缀
        if (currentLang !== config.defaultLang) currentPath = currentPath.replace(config.langMap[currentLang].path, '/');
        // 构建新路径
        const targetInfo = config.langMap[targetLang];
        return targetInfo.isRoot ? currentPath : targetInfo.path + currentPath.replace(/^\//, '');
    }
    // ====================== 主执行逻辑 ======================
    (async function executeLanguageSwitch() {
        // 参数检测
        const force_lang = getUrlLangParam();
        // 立即检测语言（同步）
        let targetLang = detectTargetLanguage();
        const currentLang = getCurrentLangFromURL();
        browser_lang = targetLang;
        if (force_lang === 'zh') ;
        else if (force_lang === 'en' || force_lang === 'ja') targetLang = force_lang;
        if (!shouldSwitchToTargetLang(currentLang, targetLang)) return;
        const newPath = buildNewPath(targetLang);
        if (newPath !== location.pathname) window.location.href = newPath + location.search;
    })();
    // ====================== 公共API ======================
    window.i18nSwitcher = {
        switchLanguage: function(lang) {
            if (!config.langMap[lang]) return;
            localStorage.setItem(config.storageKey, lang);
            document.cookie = `${config.storageKey}=${lang};path=/;max-age=31536000`;
            applyLanguage(lang);
        },
        getCurrentLang: function() {
            return detectInitialLanguage();
        }
    };
})();

//# sourceMappingURL=rebocap_new.0cf58e5d.js.map
